// @ts-nocheck
/**
 * Payment Calculator Modal
 * Handles the payment plan calculation and confirmation flow
 */

(function () {
  "use strict";

  // Configuration - update with your Cloudflare Worker URL
  const WORKER_URL = "https://payment-system-prod.partnerships-432.workers.dev";

  window.showPaymentCalculator = function (options) {
    const {
      duration,
      variantId,
      productTitle,
      totalPrice,
      customerId,
      customerEmail,
      customerFirstName,
      customerLastName,
      programStartDate, // Real program start date from metafield
      programTerm,
      upsells,
      upsellsTotal,
    } = options;

    // Calculate base program price and deposit
    const depositAmount = 30000; // €300.00 in cents
    const baseProgramPrice = totalPrice - (upsellsTotal || 0);
    const subtotal = totalPrice;
    const amountDue = totalPrice - depositAmount;

    // Count upsells
    const upsellsCount = upsells ? Object.keys(upsells).length : 0;

    // Format program start date
    let formattedStartDate = "";
    if (programStartDate) {
      const dateObj = new Date(programStartDate);
      formattedStartDate = dateObj.toLocaleDateString("en-US", {
        month: "short",
        day: "2-digit",
        year: "numeric",
      });
    }

    // Build program info summary HTML
    let programInfoHTML = `
      <div class="payment-calculator__program-info">
        <p class="payment-calculator__program-title">
          <strong>${productTitle}</strong> - ${duration} weeks${
            formattedStartDate ? ` - ${formattedStartDate}` : ""
          }
        </p>
        <div class="payment-calculator__breakdown">
          <div class="payment-calculator__breakdown-row">
            <span>Base Program:</span>
            <span>€${(baseProgramPrice / 100).toLocaleString("en-US", {
              minimumFractionDigits: 2,
            })}</span>
          </div>`;

    // Add upsells row if any
    if (upsellsCount > 0) {
      programInfoHTML += `
          <div class="payment-calculator__breakdown-row">
            <span>Add-ons:</span>
            <span>€${(upsellsTotal / 100).toLocaleString("en-US", {
              minimumFractionDigits: 2,
            })} (${upsellsCount} item${upsellsCount > 1 ? "s" : ""})</span>
          </div>`;
    }

    programInfoHTML += `
          <div class="payment-calculator__breakdown-row payment-calculator__breakdown-subtotal">
            <span>Subtotal:</span>
            <span>€${(subtotal / 100).toLocaleString("en-US", {
              minimumFractionDigits: 2,
            })}</span>
          </div>
          <div class="payment-calculator__breakdown-row payment-calculator__breakdown-deposit">
            <span>Deposit Paid:</span>
            <span>-€${(depositAmount / 100).toLocaleString("en-US", {
              minimumFractionDigits: 2,
            })}</span>
          </div>
          <div class="payment-calculator__breakdown-separator"></div>
          <div class="payment-calculator__breakdown-row payment-calculator__breakdown-total">
            <span>Amount Due:</span>
            <span>€${(amountDue / 100).toLocaleString("en-US", {
              minimumFractionDigits: 2,
            })}</span>
          </div>
        </div>
      </div>`;

    // Create modal HTML
    const modalHTML = `
      <div id="payment-calculator-modal" class="payment-calculator-modal" style="display: none;">
        <div class="payment-calculator__overlay"></div>
        <div class="payment-calculator__dialog">
          <div class="payment-calculator__header">
            <h2 class="payment-calculator__title">Payment Plan</h2>
            <button class="payment-calculator__close" aria-label="Close">&times;</button>
          </div>

          <div class="payment-calculator__body">
            ${programInfoHTML}

            <!-- Step 1: Choose Payment Type -->
            <div id="step-1-choose-type" class="payment-calculator__step" style="display: block;">
              <h3 class="payment-calculator__step-title">Choose Your Payment Option</h3>
              <div class="payment-calculator__loading">
                <p>Loading payment options...</p>
              </div>
            </div>

            <!-- Step 2a: Full Payment -->
            <div id="step-2-full-payment" class="payment-calculator__step" style="display: none;">
              <div class="payment-calculator__header-row">
                <button id="back-to-step-1-full" class="payment-calculator__back-btn">← Back</button>
                <h3 class="payment-calculator__step-title">Full Payment</h3>
              </div>
              <div id="full-payment-preview" class="payment-calculator__preview">
                <div class="payment-calculator__loading">
                  <p>Preparing payment...</p>
                </div>
              </div>
            </div>

            <!-- Step 2b: Installments -->
            <div id="step-2-installments" class="payment-calculator__step" style="display: none;">
              <div class="payment-calculator__header-row">
                <button id="back-to-step-1-installments" class="payment-calculator__back-btn">← Back</button>
                <h3 class="payment-calculator__step-title">Payment in Installments</h3>
              </div>
              
              <div id="slider-section" class="payment-calculator__slider-section" style="display: none;">
                <label for="installments-slider" class="payment-calculator__label">
                  Number of Installments
                </label>
                <div class="payment-calculator__slider-container">
                  <input
                    type="range"
                    id="installments-slider"
                    class="payment-calculator__slider"
                    min="2"
                    max="2"
                    value="2"
                    step="1"
                  >
                  <span class="payment-calculator__slider-value">2</span>
                </div>
              </div>

              <div id="payment-schedule-preview" class="payment-calculator__preview">
                <div class="payment-calculator__loading">
                  <p>Calculating payment schedule...</p>
                </div>
              </div>
            </div>

            <div class="payment-calculator__actions" id="modal-actions">
              <button id="confirm-payment" class="payment-calculator__btn payment-calculator__btn--primary" disabled style="display: none;">
                Confirm Payment Plan
              </button>
              <button id="pay-now-full" class="payment-calculator__btn payment-calculator__btn--primary" style="display: none;">
                Pay Now
              </button>
            </div>
          </div>
        </div>
      </div>
    `;

    // Remove existing modal if present to ensure clean state
    let existingModal = document.getElementById("payment-calculator-modal");
    if (existingModal) {
      existingModal.remove();
    }

    // Add fresh modal to DOM
    document.body.insertAdjacentHTML("beforeend", modalHTML);
    const modal = document.getElementById("payment-calculator-modal");

    // Show modal
    modal.style.display = "block";

    // Get elements
    const step1 = modal.querySelector("#step-1-choose-type");
    const step2Full = modal.querySelector("#step-2-full-payment");
    const step2Installments = modal.querySelector("#step-2-installments");
    const sliderSection = modal.querySelector("#slider-section");
    const slider = modal.querySelector("#installments-slider");
    const sliderValue = modal.querySelector(
      ".payment-calculator__slider-value",
    );
    const previewContainer = modal.querySelector("#payment-schedule-preview");
    const fullPaymentPreview = modal.querySelector("#full-payment-preview");
    const confirmBtn = modal.querySelector("#confirm-payment");
    const payNowBtn = modal.querySelector("#pay-now-full");
    const closeBtn = modal.querySelector(".payment-calculator__close");
    const overlay = modal.querySelector(".payment-calculator__overlay");
    const programInfo = modal.querySelector(
      ".payment-calculator__program-info",
    );
    const backToStep1Full = modal.querySelector("#back-to-step-1-full");
    const backToStep1Installments = modal.querySelector(
      "#back-to-step-1-installments",
    );

    let currentSchedule = null;
    let fullPaymentLink = null;
    let fullPaymentAmount = null; // Store discounted amount for full payment
    let isProcessing = false; // Flag to prevent modal closure during API calls

    function isAutomaticInstallmentsAvailable(schedule) {
      return Boolean(
        schedule &&
          schedule.isValid &&
          !schedule.requiresManualProcessing &&
          schedule.installmentCount >= 2,
      );
    }

    function renderInstallmentsUnavailable(schedule) {
      const primaryMessage =
        "Automatic monthly installments are not available for this start date.";
      const secondaryMessage = schedule?.requiresManualProcessing
        ? "This case requires manual processing. Please contact us at shadow@doctorsinitaly.com."
        : "Please contact us at shadow@doctorsinitaly.com for assistance.";

      previewContainer.innerHTML = `
        <div class="payment-calculator__error">
          <p>${primaryMessage}</p>
          <p style="font-size: 12px; margin-top: 8px;">${secondaryMessage}</p>
        </div>
      `;
    }

    // Navigation functions
    function showStep1() {
      step1.style.display = "block";
      step2Full.style.display = "none";
      step2Installments.style.display = "none";
      confirmBtn.style.display = "none";
      payNowBtn.style.display = "none";
      programInfo.style.display = "block";

      // Reset slider to initial state when going back
      slider.max = "2";
      slider.value = "2";
      sliderValue.textContent = "2";
      sliderSection.style.display = "none";
    }

    function showStep2Full() {
      step1.style.display = "none";
      step2Full.style.display = "block";
      step2Installments.style.display = "none";
      confirmBtn.style.display = "none";
      payNowBtn.style.display = "block";
      payNowBtn.disabled = true;
      programInfo.style.display = "none";
    }

    function showStep2Installments() {
      step1.style.display = "none";
      step2Full.style.display = "none";
      step2Installments.style.display = "block";
      confirmBtn.style.display = "block";
      payNowBtn.style.display = "none";
      confirmBtn.disabled = true;
      programInfo.style.display = "none";
    }

    // Back buttons
    backToStep1Full.addEventListener("click", showStep1);
    backToStep1Installments.addEventListener("click", showStep1);

    // Debounce timer for slider
    let sliderDebounceTimer = null;

    // Remove hover effects on slider by preventing CSS from applying
    slider.addEventListener("mouseenter", function () {
      this.style.setProperty("--thumb-hover-scale", "1", "important");
    });

    slider.addEventListener("mouseleave", function () {
      this.style.setProperty("--thumb-hover-scale", "1", "important");
    });

    // Update preview when slider changes
    slider.addEventListener("input", function () {
      sliderValue.textContent = this.value;
      confirmBtn.disabled = true;

      // Clear previous timer
      if (sliderDebounceTimer) {
        clearTimeout(sliderDebounceTimer);
      }

      // Wait 400ms after user stops moving slider
      sliderDebounceTimer = setTimeout(async () => {
        await calculateScheduleForInstallments(parseInt(this.value));
      }, 400);
    });

    // Calculate schedule from Worker
    async function calculateSchedule(numInstallments) {
      try {
        // Read affiliate code from localStorage (if present)
        let affiliateCode = null;
        try {
          const savedRef = localStorage.getItem("referral_code");
          console.log("[PaymentCalc] 🔍 localStorage referral_code:", savedRef);
          if (savedRef && savedRef.trim() !== "") {
            affiliateCode = savedRef.trim();
            console.log(
              "[PaymentCalc] ✅ Using affiliate code:",
              affiliateCode,
            );
          } else {
            console.log("[PaymentCalc] ⚠️ No affiliate code in localStorage");
          }
        } catch (err) {
          console.warn("[PaymentCalc] ❌ Could not read affiliate code:", err);
        }

        // Build upsell variant IDs for canonical pricing
        const upsellVariantIds = (
          window.upsellsCalculator?.getLineItems() || []
        ).map(function (item) {
          return {
            variantId: String(item.variant_id),
            quantity: item.quantity,
          };
        });

        const response = await fetch(`${WORKER_URL}/api/calculate-schedule`, {
          method: "POST",
          headers: {
            "Content-Type": "application/json",
          },
          body: JSON.stringify({
            todayDate: new Date().toISOString().split("T")[0],
            programStartDate: programStartDate,
            variantId: variantId,
            upsellVariantIds:
              upsellVariantIds.length > 0 ? upsellVariantIds : undefined,
            totalPrice: totalPrice, // legacy fallback
            numberOfInstallments: numInstallments,
            affiliateCode: affiliateCode,
            customerId: customerId,
          }),
        });

        if (!response.ok) {
          throw new Error(`HTTP ${response.status}: ${response.statusText}`);
        }

        const data = await response.json();
        console.log("[PaymentCalc] 📦 Backend response:", data);

        if (data.success) {
          currentSchedule = data.schedule;
          if (data.schedule.discountInfo) {
            console.log(
              "[PaymentCalc] 💰 Discount info received:",
              data.schedule.discountInfo,
            );
          } else {
            console.log("[PaymentCalc] ℹ️ No discount info in response");
          }
          return data.schedule;
        } else {
          throw new Error(data.error || "Calculation failed");
        }
      } catch (error) {
        console.error("Calculation error:", error);
        throw error;
      }
    }

    // Calculate schedule for installments (Step 2b)
    async function calculateScheduleForInstallments(numInstallments) {
      try {
        const loadingStartTime = Date.now();
        const minLoadingTime = 300; // Minimum 300ms to avoid flash

        previewContainer.innerHTML =
          '<div class="payment-calculator__loading"><p>Calculating...</p></div>';

        const schedule = await calculateSchedule(numInstallments);

        // Ensure loading is shown for at least minLoadingTime
        const elapsedTime = Date.now() - loadingStartTime;
        if (elapsedTime < minLoadingTime) {
          await new Promise((resolve) =>
            setTimeout(resolve, minLoadingTime - elapsedTime),
          );
        }

        if (!isAutomaticInstallmentsAvailable(schedule)) {
          sliderSection.style.display = "none";
          renderInstallmentsUnavailable(schedule);
          confirmBtn.disabled = true;
          return;
        }

        // Configura lo slider con il massimo reale dal backend
        const actualInstallments = schedule.installmentCount;

        // If this is the first call (to discover max), configure slider
        if (slider.max === "2") {
          // First call - set real maximum
          if (actualInstallments > 2) {
            // Multiple options available - show slider
            slider.max = actualInstallments;
            // Set initial value to middle of range (min=2, max=actualInstallments)
            const initialValue = Math.ceil((2 + actualInstallments) / 2);
            slider.value = initialValue;
            sliderValue.textContent = String(initialValue);
            sliderSection.style.display = "block";

            // Ricalcola con il valore iniziale ottimale
            if (initialValue !== actualInstallments) {
              await calculateScheduleForInstallments(initialValue);
              return;
            }
          } else {
            // Only 2 installments possible - hide slider
            sliderSection.style.display = "none";
          }
        }

        displaySchedulePreview(schedule);
        confirmBtn.disabled = false;
      } catch (error) {
        console.error("Calculation error:", error);
        previewContainer.innerHTML = `
          <div class="payment-calculator__error">
            <p>Unable to calculate payment schedule</p>
            <p style="font-size: 12px; margin-top: 8px;">Please try again or contact us at shadow@doctorsinitaly.com</p>
          </div>
        `;
        confirmBtn.disabled = true;
      }
    }

    // Display schedule preview
    function displaySchedulePreview(schedule) {
      const hasMany = schedule.installments.length >= 5;
      const depositPaid = 30000; // €300 in cents
      const programTotal = totalPrice; // Total program price

      let html = '<div class="payment-calculator__schedule">';

      // Show discount banner if present
      if (schedule.discountInfo && schedule.discountInfo.applied) {
        html += `
          <div class="payment-calculator__discount-banner">
            <p>Discount applied: <strong>€${schedule.discountInfo.amount.toFixed(
              2,
            )}</strong> (${schedule.discountInfo.code})</p>
          </div>
        `;
      }

      html +=
        '<p class="payment-calculator__schedule-title">Your Payment Schedule:</p>';
      html += `<ul class="payment-calculator__installments${
        hasMany ? " payment-calculator__installments--scrollable" : ""
      }">`;

      schedule.installments.forEach((inst) => {
        // inst.dueDate is a string like "31/12/2025", convert to international format
        const [day, month, year] = inst.dueDate.split("/");
        const dateObj = new Date(year, month - 1, day);
        const dueDate = dateObj.toLocaleDateString("en-US", {
          month: "short",
          day: "numeric",
          year: "numeric",
        });
        // inst.amount is a string like "€1345.00", extract number and reformat
        const amountStr = inst.amount.replace("€", "").replace(",", ".");
        const amount = parseFloat(amountStr);
        const formattedAmount =
          "€" +
          amount.toLocaleString("en-US", {
            minimumFractionDigits: 2,
            maximumFractionDigits: 2,
          });

        html += `
          <li class="payment-calculator__installment">
            <span class="payment-calculator__installment-number">Installment ${inst.number}</span>
            <span class="payment-calculator__installment-date">by ${dueDate}</span>
            <span class="payment-calculator__installment-amount">${formattedAmount}</span>
          </li>
        `;
      });

      html += "</ul>";

      html += '<div class="installments__deadline-warning">';
      html +=
        "<p>🎯 Each installment must be submitted before the specified deadline to guarantee your spot.</p>";
      html += "</div>";

      html += "</div>";

      previewContainer.innerHTML = html;
    }

    // Display Step 1: Choose payment type
    async function displayStep1() {
      try {
        // Calculate schedule without forcing an installment count so we can
        // discover the real available options from the backend.
        const schedule = await calculateSchedule();

        const canPayFull = schedule.canPayFull;
        const canPayInstallments = isAutomaticInstallmentsAvailable(schedule);
        let remainingAmount = totalPrice - 30000; // totalPrice - deposit (€300 = 30000 cents)

        // Calculate base installment amount (WITHOUT subtracting discount from total)
        // because discount is applied only to FIRST installment, not to all
        const baseInstallmentAmount = canPayInstallments
          ? remainingAmount / 100 / schedule.installmentCount
          : null;

        // Apply affiliate discount only for display in Full Payment
        let fullPaymentAmount = remainingAmount;
        if (schedule.discountInfo && schedule.discountInfo.applied) {
          fullPaymentAmount -= schedule.discountInfo.amount * 100; // Subtract €100 = 10000 cents
        }

        let html = '<div class="payment-calculator__payment-options">';

        // Full Payment Option
        if (canPayFull) {
          html += `
            <button class="payment-option payment-option--full" data-option="full">
              <div class="payment-option__icon">💰</div>
              <div class="payment-option__content">
                <h4 class="payment-option__title">Full Payment</h4>
                <p class="payment-option__description">Pay the remaining balance in one payment</p>
                <p class="payment-option__amount">€${(
                  fullPaymentAmount / 100
                ).toLocaleString("en-US", { minimumFractionDigits: 2 })}</p>
              </div>
              <div class="payment-option__arrow">→</div>
            </button>
          `;
        } else {
          html += `
            <div class="payment-option payment-option--full payment-option--disabled">
              <div class="payment-option__icon">💰</div>
              <div class="payment-option__content">
                <h4 class="payment-option__title">Full Payment</h4>
                <p class="payment-option__description">This option is no longer available online</p>
                <p class="payment-option__amount">Online full payment is available up to 90 days before your start date</p>
              </div>
            </div>
          `;
        }

        // Installments Option
        if (canPayInstallments) {
          html += `
          <button class="payment-option payment-option--installments" data-option="installments">
            <div class="payment-option__icon">📅</div>
            <div class="payment-option__content">
              <h4 class="payment-option__title">Pay in Installments</h4>
              <p class="payment-option__description">Split your payment into monthly installments</p>
              <p class="payment-option__amount">From €${baseInstallmentAmount.toLocaleString(
                "en-US",
                {
                  minimumFractionDigits: 2,
                  maximumFractionDigits: 2,
                },
              )} / month</p>
            </div>
            <div class="payment-option__arrow">→</div>
          </button>
          `;
        } else {
          html += `
            <div class="payment-option payment-option--installments payment-option--disabled">
              <div class="payment-option__icon">&#128197;</div>
              <div class="payment-option__content">
                <h4 class="payment-option__title">Pay in Installments</h4>
                <p class="payment-option__description">Monthly installments are not available online for this start date</p>
                <p class="payment-option__amount">Contact Admissions for support</p>
              </div>
            </div>
          `;
        }

        html += "</div>";

        step1.querySelector(".payment-calculator__loading").outerHTML = html;

        // Add event listeners to payment options
        const fullPaymentBtn = step1.querySelector('[data-option="full"]');
        const installmentsBtn = step1.querySelector(
          '[data-option="installments"]',
        );

        if (fullPaymentBtn) {
          fullPaymentBtn.addEventListener("click", async function () {
            showStep2Full();
            await prepareFullPayment();
          });
        }

        if (installmentsBtn) {
          installmentsBtn.addEventListener("click", async function () {
            showStep2Installments();
            await calculateScheduleForInstallments();
          });
        }
      } catch (error) {
        console.error("Error displaying Step 1:", error);
        step1.innerHTML = `
          <div class="payment-calculator__error">
            <p>Unable to load payment options</p>
            <p style="font-size: 12px; margin-top: 8px;">Please try again or contact us at shadow@doctorsinitaly.com</p>
          </div>
        `;
      }
    }

    // Prepare Full Payment (Step 2a)
    async function prepareFullPayment() {
      try {
        fullPaymentPreview.innerHTML =
          '<div class="payment-calculator__loading"><p>Preparing payment...</p></div>';

        // Calculate schedule with 1 installment ONLY to validate affiliate code and get discountInfo
        const schedule = await calculateSchedule(1);

        const depositPaid = 30000; // €300 in cents
        const programTotal = totalPrice; // Total program price
        let remainingAmount = totalPrice - depositPaid; // Remaining balance (WITHOUT deposit)

        // If there's an affiliate discount, subtract it from remaining amount
        if (schedule.discountInfo && schedule.discountInfo.applied) {
          remainingAmount -= schedule.discountInfo.amount * 100; // Convert €100 to cents (10000)
        }

        let html = '<div class="payment-calculator__schedule">';

        // Show discount banner if present
        if (schedule.discountInfo && schedule.discountInfo.applied) {
          html += `
            <div class="payment-calculator__discount-banner">
              <p>Discount applied: <strong>€${schedule.discountInfo.amount.toFixed(
                2,
              )}</strong> (${schedule.discountInfo.code})</p>
            </div>
          `;
        }

        html +=
          '<p class="payment-calculator__schedule-title">Your Payment:</p>';
        html += '<ul class="payment-calculator__installments">';

        // Calculate deadline: 90 days before program start date
        const startDate = new Date(programStartDate);
        const deadlineDate = new Date(startDate);
        deadlineDate.setDate(startDate.getDate() - 90);

        const formattedDeadline = deadlineDate.toLocaleDateString("en-US", {
          month: "short",
          day: "numeric",
          year: "numeric",
        });

        html += `
          <li class="payment-calculator__installment">
            <span class="payment-calculator__installment-number">Full Payment</span>
            <span class="payment-calculator__installment-date">by ${formattedDeadline}</span>
            <span class="payment-calculator__installment-amount">€${(
              remainingAmount / 100
            ).toLocaleString("en-US", { minimumFractionDigits: 2 })}</span>
          </li>
        `;

        html += "</ul>";

        html += '<div class="full-payment__note">';
        html +=
          "<p>💡 By choosing full payment, you complete your payment obligation in one transaction.</p>";
        html += "</div>";

        html += '<div class="full-payment__deadline-warning">';
        html += `<p>🎯 Payment must be submitted before ${formattedDeadline} to guarantee your spot.</p>`;
        html += "</div>";

        html += "</div>";

        fullPaymentPreview.innerHTML = html;
        payNowBtn.disabled = false;

        // Store the discounted amount for use in payNowBtn click handler
        fullPaymentAmount = remainingAmount;
      } catch (error) {
        console.error("Error preparing full payment:", error);
        fullPaymentPreview.innerHTML = `
          <div class="payment-calculator__error">
            <p>Unable to prepare payment</p>
            <p style="font-size: 12px; margin-top: 8px;">Please try again or contact us at shadow@doctorsinitaly.com</p>
          </div>
        `;
        payNowBtn.disabled = true;
      }
    }

    // Confirm payment plan (for installments)
    confirmBtn.addEventListener("click", async function () {
      if (!currentSchedule) return;

      if (!isAutomaticInstallmentsAvailable(currentSchedule)) {
        renderInstallmentsUnavailable(currentSchedule);
        this.disabled = true;
        return;
      }

      this.disabled = true;
      this.textContent = "Processing...";
      isProcessing = true; // Block modal closure

      try {
        // Get session token from Shopify (if available)
        let authHeader = {};
        if (
          typeof window.Shopify !== "undefined" &&
          window.Shopify.customerPrivacy
        ) {
          try {
            const sessionToken =
              await window.Shopify.customerPrivacy.getSessionToken();
            if (sessionToken) {
              console.log(
                "✅ Session token obtained:",
                sessionToken.substring(0, 20) + "...",
              );
              authHeader = { Authorization: `Bearer ${sessionToken}` };
            } else {
              console.warn("⚠️ Session token is null or undefined");
            }
          } catch (err) {
            console.warn("⚠️ Could not get Shopify session token:", err);
          }
        } else {
          console.warn("⚠️ window.Shopify.customerPrivacy not available");
        }

        const response = await fetch(
          `${WORKER_URL}/api/generate-payment-links`,
          {
            method: "POST",
            headers: {
              "Content-Type": "application/json",
              ...authHeader,
            },
            body: JSON.stringify({
              customerId: customerId,
              customerEmail: customerEmail,
              customerFirstName: customerFirstName,
              customerLastName: customerLastName,
              variantId: variantId,
              requestedInstallments: currentSchedule.installmentCount,
              programStartDate: programStartDate,
              upsells: (window.upsellsCalculator?.getLineItems() || []).map(
                function (item) {
                  return {
                    variant_id: item.variant_id,
                    quantity: item.quantity,
                  };
                },
              ),
              programDetails: {
                name: productTitle,
                duration: duration,
                weeks: duration,
                term: programTerm,
              },
            }),
          },
        );

        if (!response.ok) {
          throw new Error("Failed to generate payment links");
        }

        const data = await response.json();

        if (data.success) {
          // Show success message
          previewContainer.innerHTML = `
            <div class="payment-calculator__success">
              <p style="font-size: 18px; font-weight: 600; margin-bottom: 12px;">✓ Payment Plan Confirmed!</p>
              <p>Your payment links are now available in your dashboard</p>
              <p style="font-size: 12px; color: #666; margin-top: 12px;">Your application status has been updated to "Paying Fellow"</p>
              <p style="font-size: 14px; margin-top: 16px; opacity: 0.7;">Redirecting in 3 seconds...</p>
            </div>
          `;

          // Hide button to prevent double-clicks
          confirmBtn.style.display = "none";

          // Auto-close after 3 seconds
          setTimeout(() => {
            modal.style.display = "none";
            window.location.reload();
          }, 3000);
        } else {
          throw new Error(data.error || "Payment confirmation failed");
        }
      } catch (error) {
        console.error("Confirmation error:", error);
        previewContainer.innerHTML = `
          <div class="payment-calculator__error">
            <p>Unable to confirm payment plan</p>
            <p style="font-size: 12px; margin-top: 8px;">Please try again or contact us at shadow@doctorsinitaly.com</p>
          </div>
        `;

        confirmBtn.textContent = "Confirm Payment Plan";
        confirmBtn.disabled = false;
        isProcessing = false; // Re-enable modal closure on error
      }
    });

    // Pay Now button (for full payment)
    payNowBtn.addEventListener("click", async function () {
      this.disabled = true;
      this.textContent = "Processing...";
      isProcessing = true; // Block modal closure

      try {
        // Get session token from Shopify (if available)
        let authHeader = {};
        if (
          typeof window.Shopify !== "undefined" &&
          window.Shopify.customerPrivacy
        ) {
          try {
            const sessionToken =
              await window.Shopify.customerPrivacy.getSessionToken();
            if (sessionToken) {
              console.log(
                "✅ Session token obtained:",
                sessionToken.substring(0, 20) + "...",
              );
              authHeader = { Authorization: `Bearer ${sessionToken}` };
            } else {
              console.warn("⚠️ Session token is null or undefined");
            }
          } catch (err) {
            console.warn("⚠️ Could not get Shopify session token:", err);
          }
        } else {
          console.warn("⚠️ window.Shopify.customerPrivacy not available");
        }

        const response = await fetch(
          `${WORKER_URL}/api/generate-payment-links`,
          {
            method: "POST",
            headers: {
              "Content-Type": "application/json",
              ...authHeader,
            },
            body: JSON.stringify({
              customerId: customerId,
              customerEmail: customerEmail,
              customerFirstName: customerFirstName,
              customerLastName: customerLastName,
              variantId: variantId,
              requestedInstallments: 1,
              programStartDate: programStartDate,
              upsells: (window.upsellsCalculator?.getLineItems() || []).map(
                function (item) {
                  return {
                    variant_id: item.variant_id,
                    quantity: item.quantity,
                  };
                },
              ),
              programDetails: {
                name: productTitle,
                duration: duration,
                weeks: duration,
                term: programTerm,
              },
            }),
          },
        );

        if (!response.ok) {
          throw new Error("Failed to generate payment link");
        }

        const data = await response.json();

        if (
          data.success &&
          ((data.paymentLinks && data.paymentLinks.length > 0) ||
            data.alreadyComplete)
        ) {
          // Show success message (same behavior as installments)
          fullPaymentPreview.innerHTML = `
            <div class="payment-calculator__success">
              <p style="font-size: 18px; font-weight: 600; margin-bottom: 12px;">✓ Payment Link Created!</p>
              <p>Your payment link is now available in your dashboard</p>
              <p style="font-size: 12px; color: #666; margin-top: 12px;">Your application status has been updated to "Paying Fellow"</p>
              <p style="font-size: 14px; margin-top: 16px; opacity: 0.7;">Redirecting in 3 seconds...</p>
            </div>
          `;

          // Hide button to prevent double-clicks
          payNowBtn.style.display = "none";

          // Auto-close after 3 seconds
          setTimeout(() => {
            modal.style.display = "none";
            window.location.reload();
          }, 3000);
        } else {
          throw new Error(data.error || "Payment link generation failed");
        }
      } catch (error) {
        console.error("Payment error:", error);
        fullPaymentPreview.innerHTML = `
          <div class="payment-calculator__error">
            <p>Unable to create payment link</p>
            <p style="font-size: 12px; margin-top: 8px;">Please try again or contact us at shadow@doctorsinitaly.com</p>
          </div>
        `;

        payNowBtn.textContent = "Pay Now";
        payNowBtn.disabled = false;
        isProcessing = false; // Re-enable modal closure on error
      }
    });

    // Close modal handlers
    [closeBtn, overlay].forEach((el) => {
      el.addEventListener("click", function () {
        // Prevent closing if API call is in progress
        if (isProcessing) {
          console.warn("⚠️ Cannot close modal while processing payment");
          return;
        }
        modal.style.display = "none";
      });
    });

    // Initialize: Show Step 1
    displayStep1();
  };

  // Add styles
  const style = document.createElement("style");
  style.textContent = `
    .payment-calculator-modal {
      position: fixed;
      top: 0;
      left: 0;
      width: 100%;
      height: 100%;
      z-index: 1000;
    }

    .payment-calculator__overlay {
      position: absolute;
      top: 0;
      left: 0;
      width: 100%;
      height: 100%;
      background: rgba(0, 0, 0, 0.5);
      cursor: pointer;
    }

    .payment-calculator__dialog {
      position: absolute;
      top: 50%;
      left: 50%;
      transform: translate(-50%, -50%);
      width: 90%;
      max-width: 500px;
      background: white;
      border-radius: 12px;
      box-shadow: 0 20px 60px rgba(0, 0, 0, 0.3);
      max-height: 90vh;
      overflow-y: auto;
    }

    .payment-calculator__header {
      display: flex;
      justify-content: space-between;
      align-items: center;
      padding: 24px;
      border-bottom: 1px solid #e5e7eb;
    }

    .payment-calculator__title {
      margin: 0;
      font-size: 24px;
      font-weight: 700;
      color: #000;
    }

    .payment-calculator__close {
      background: none;
      border: none;
      font-size: 32px;
      cursor: pointer;
      color: #666;
      width: 32px;
      height: 32px;
      display: flex;
      align-items: center;
      justify-content: center;
      padding: 0;
      transition: color 0.2s ease;
    }

    .payment-calculator__close:hover {
      color: #000;
    }

    .payment-calculator__body {
      padding: 24px;
    }

    .payment-calculator__program-info {
      background: #f9fafb;
      padding: 20px;
      border-radius: 8px;
      margin-bottom: 24px;
    }

    .payment-calculator__program-title {
      margin: 0 0 16px 0 !important;
      font-size: 15px !important;
      color: #333 !important;
      padding-bottom: 12px;
      border-bottom: 1px solid #e5e7eb;
    }

    .payment-calculator__breakdown {
      display: flex;
      flex-direction: column;
      gap: 8px;
    }

    .payment-calculator__breakdown-row {
      display: flex;
      justify-content: space-between;
      align-items: center;
      font-size: 14px;
      color: #666;
    }

    .payment-calculator__breakdown-row span:last-child {
      font-weight: 500;
      color: #333;
    }

    .payment-calculator__breakdown-subtotal {
      margin-top: 4px;
      padding-top: 8px;
      border-top: 1px solid #e5e7eb;
    }

    .payment-calculator__breakdown-deposit {
      color: #059669;
    }

    .payment-calculator__breakdown-deposit span {
      color: #059669;
    }

    .payment-calculator__breakdown-separator {
      height: 1px;
      background: #333;
      margin: 8px 0;
    }

    .payment-calculator__breakdown-total {
      font-size: 16px !important;
      font-weight: 700 !important;
      color: #000 !important;
    }

    .payment-calculator__breakdown-total span {
      font-weight: 700 !important;
      color: #78227b !important;
    }

    .payment-calculator__program-info p {
      margin: 0 0 8px 0;
      font-size: 14px;
      color: #666;
    }

    .payment-calculator__program-info p:last-child {
      margin-bottom: 0;
    }

    .payment-calculator__total {
      font-size: 16px !important;
      font-weight: 600 !important;
      color: #000 !important;
      margin-top: 8px !important;
    }

    .payment-calculator__step {
      min-height: 200px;
    }

    .payment-calculator__step-title {
      margin: 0 0 20px 0;
      font-size: 18px;
      font-weight: 600;
      color: #000;
    }

    .payment-calculator__header-row {
      display: flex;
      align-items: center;
      justify-content: center;
      margin-bottom: 16px;
      position: relative;
    }

    .payment-calculator__header-row .payment-calculator__back-btn {
      position: absolute;
      left: 0;
    }

    .payment-calculator__header-row .payment-calculator__step-title {
      text-align: center;
    }

    .payment-calculator__back-button-container {
      margin-bottom: 16px;
    }

    .payment-calculator__back-btn {
      background: none;
      border: none;
      color: #78227b;
      font-size: 14px;
      font-weight: 600;
      cursor: pointer;
      padding: 8px 0;
      transition: opacity 0.2s ease;
      flex-shrink: 0;
    }

    .payment-calculator__back-btn:hover {
      opacity: 0.7;
    }

    /* Payment Options (Step 1) */
    .payment-calculator__payment-options {
      display: flex;
      flex-direction: column;
      gap: 16px;
    }

    .payment-option {
      display: flex;
      align-items: center;
      gap: 16px;
      padding: 20px;
      background: #f9fafb;
      border: 2px solid #e5e7eb;
      border-radius: 12px;
      cursor: pointer;
      transition: all 0.2s ease;
      text-align: left;
      width: 100%;
    }

    .payment-option:hover:not(.payment-option--disabled) {
      border-color: #78227b;
      background: #faf5fb;
      transform: translateY(-2px);
      box-shadow: 0 4px 12px rgba(120, 34, 123, 0.1);
    }

    .payment-option--disabled {
      opacity: 0.5;
      cursor: not-allowed;
    }

    .payment-option__icon {
      font-size: 32px;
      flex-shrink: 0;
    }

    .payment-option__content {
      flex: 1;
    }

    .payment-option__title {
      margin: 0 0 4px 0;
      font-size: 16px;
      font-weight: 700;
      color: #000;
    }

    .payment-option__description {
      margin: 0 0 8px 0;
      font-size: 13px;
      color: #666;
      line-height: 1.4;
    }

    .payment-option__amount {
      margin: 0;
      font-size: 18px;
      font-weight: 700;
      color: #78227b;
    }

    .payment-option__arrow {
      font-size: 24px;
      color: #78227b;
      flex-shrink: 0;
    }

    /* Full Payment Summary (Step 2a) */
    .full-payment__note {
      padding: 12px;
      background: #eff6ff;
      border: 1px solid #bfdbfe;
      border-radius: 6px;
      margin-top: 16px;
    }

    .full-payment__note p {
      margin: 0;
      font-size: 13px;
      color: #1e40af;
      line-height: 1.5;
    }

    .full-payment__deadline-warning {
      padding: 12px;
      background: #fffbeb;
      border: 1px solid #fcd34d;
      border-radius: 6px;
      margin-top: 12px;
    }

    .full-payment__deadline-warning p {
      margin: 0;
      font-size: 13px;
      color: #92400e;
      line-height: 1.5;
    }

    .installments__deadline-warning {
      padding: 12px;
      background: #fffbeb;
      border: 1px solid #fcd34d;
      border-radius: 6px;
      margin-top: 16px;
    }

    .installments__deadline-warning p {
      margin: 0;
      font-size: 13px;
      color: #92400e;
      line-height: 1.5;
    }

    .payment-calculator__label {
      display: block;
      font-size: 14px;
      font-weight: 600;
      color: #000;
      margin-bottom: 12px;
    }

    .payment-calculator__slider-container {
      display: flex;
      align-items: center;
      gap: 16px;
      margin-bottom: 24px;
    }

    .payment-calculator__slider {
      flex: 1;
      height: 6px;
      border-radius: 3px;
      outline: none;
      -webkit-appearance: none;
      appearance: none;
      background: #e5e7eb;
      pointer-events: auto;
    }

    .payment-calculator__slider::-webkit-slider-thumb {
      -webkit-appearance: none !important;
      appearance: none !important;
      width: 20px !important;
      height: 20px !important;
      border-radius: 50% !important;
      background: rgb(120, 34, 123) !important;
      cursor: grab !important;
      box-shadow: 0 2px 4px rgba(120, 34, 123, 0.3) !important;
      border: none !important;
      padding: 0 !important;
      margin-top: -7px !important;
      outline: none !important;
    }

    .payment-calculator__slider::-webkit-slider-thumb:hover {
      background: rgb(120, 34, 123) !important;
      box-shadow: 0 2px 4px rgba(120, 34, 123, 0.3) !important;
    }

    .payment-calculator__slider::-webkit-slider-thumb:focus {
      background: rgb(120, 34, 123) !important;
      box-shadow: 0 2px 4px rgba(120, 34, 123, 0.3) !important;
      outline: none !important;
    }

    .payment-calculator__slider::-webkit-slider-thumb:active {
      background: rgb(120, 34, 123) !important;
      box-shadow: 0 2px 4px rgba(120, 34, 123, 0.3) !important;
    }

    .payment-calculator__slider::-moz-range-thumb {
      width: 20px !important;
      height: 20px !important;
      border-radius: 50% !important;
      background: rgb(120, 34, 123) !important;
      cursor: grab !important;
      border: none !important;
      box-shadow: 0 2px 4px rgba(120, 34, 123, 0.3) !important;
      padding: 0 !important;
      margin: 0 !important;
      outline: none !important;
    }

    .payment-calculator__slider::-moz-range-thumb:hover {
      background: rgb(120, 34, 123) !important;
      box-shadow: 0 2px 4px rgba(120, 34, 123, 0.3) !important;
    }

    .payment-calculator__slider::-moz-range-thumb:focus {
      background: rgb(120, 34, 123) !important;
      box-shadow: 0 2px 4px rgba(120, 34, 123, 0.3) !important;
      outline: none !important;
    }

    .payment-calculator__slider::-moz-range-thumb:active {
      background: rgb(120, 34, 123) !important;
      box-shadow: 0 2px 4px rgba(120, 34, 123, 0.3) !important;
    }

    .payment-calculator__slider::-moz-range-track {
      background: #e5e7eb !important;
      border: none !important;
      height: 6px !important;
      border-radius: 3px !important;
    }

    .payment-calculator__slider::-webkit-slider-runnable-track {
      background: #e5e7eb !important;
      border: none !important;
      height: 6px !important;
      border-radius: 3px !important;
    }

    .payment-calculator__slider-value {
      min-width: 40px;
      text-align: center;
      font-weight: 600;
      font-size: 16px;
      color: #78227b;
    }

    .payment-calculator__preview {
      margin-bottom: 24px;
      min-height: 200px;
    }

    .payment-calculator__loading {
      text-align: center;
      padding: 40px 0;
      color: #666;
    }

    .payment-calculator__schedule {
      background: #f9fafb;
      padding: 16px;
      border-radius: 8px;
    }

    .payment-calculator__summary-box {
      background: #fff;
      border: 1px solid #e5e7eb;
      border-radius: 6px;
      padding: 12px;
      margin-bottom: 16px;
      font-size: 13px;
    }

    .payment-summary-item {
      display: flex;
      justify-content: space-between;
      align-items: center;
      padding: 6px 0;
    }

    .payment-summary-item--total {
      margin-top: 6px;
      padding-top: 10px;
      border-top: 1px solid #e5e7eb;
      font-weight: 600;
    }

    .payment-summary-label {
      color: #666;
      font-size: 12px;
    }

    .payment-summary-item--total .payment-summary-label {
      color: #000;
      font-size: 13px;
    }

    .payment-summary-value {
      font-weight: 600;
      color: #000;
    }

    .payment-summary-value--paid {
      color: #16a34a;
    }

    .payment-summary-item--total .payment-summary-value {
      font-size: 15px;
      color: #78227b;
    }

    .payment-calculator__discount-banner {
      background: #f9fafb;
      border: 1px solid #e5e7eb;
      border-radius: 6px;
      padding: 8px 12px;
      margin-bottom: 12px;
    }

    .payment-calculator__discount-banner p {
      margin: 0;
      color: #6b7280;
      font-size: 12px;
      line-height: 1.5;
    }

    .payment-calculator__discount-banner strong {
      color: #16a34a;
      font-weight: 600;
    }

    .payment-calculator__schedule-title {
      margin: 0 0 12px 0;
      font-size: 14px;
      font-weight: 600;
      color: #000;
    }

    .payment-calculator__installments {
      list-style: none;
      margin: 0 0 16px 0;
      padding: 0;
    }

    .payment-calculator__installments--scrollable {
      max-height: 250px;
      overflow-y: auto;
      border: 1px solid #e5e7eb;
      border-radius: 8px;
      padding: 8px;
      margin-bottom: 16px;
      
      /* Firefox */
      scrollbar-width: thin;
      scrollbar-color: #78227b #f1f1f1;
    }

    .payment-calculator__installments--scrollable::-webkit-scrollbar {
      width: 10px;
    }

    .payment-calculator__installments--scrollable::-webkit-scrollbar-track {
      background: #f1f1f1;
      border-radius: 4px;
      margin: 4px 0;
    }

    .payment-calculator__installments--scrollable::-webkit-scrollbar-thumb {
      background: #78227b;
      border-radius: 4px;
      border: 2px solid #f1f1f1;
    }

    .payment-calculator__installments--scrollable::-webkit-scrollbar-thumb:hover {
      background: #6c1f6f;
    }

    .payment-calculator__installment {
      display: flex;
      justify-content: space-between;
      align-items: center;
      padding: 12px 0;
      border-bottom: 1px solid #e5e7eb;
      font-size: 13px;
    }

    .payment-calculator__installment:last-child {
      border-bottom: none;
    }

    .payment-calculator__installment-number {
      font-weight: 500;
      color: #666;
      flex: 1;
      line-height: 1.4;
    }

    .payment-calculator__installment-date {
      color: #000;
      font-size: 12px;
      margin-right: 16px;
      text-align: right;
      line-height: 1.4;
    }

    .payment-calculator__installment-amount {
      font-weight: 600;
      color: #000;
      min-width: 80px;
      text-align: right;
      line-height: 1.4;
    }

    .payment-calculator__total-summary {
      margin-top: 12px;
      padding-top: 12px;
      border-top: 1px solid #e5e7eb;
      text-align: right;
      font-weight: 600;
    }

    .payment-calculator__total-summary p {
      margin: 0;
      font-size: 14px;
    }

    .payment-calculator__success {
      text-align: center;
      padding: 20px;
      background: #f0fdf4;
      border-radius: 8px;
      border: 1px solid #86efac;
    }

    .payment-calculator__success p {
      margin: 0 0 8px 0;
      color: #166534;
    }

    .payment-calculator__success a {
      color: #166534;
      text-decoration: underline;
    }

    .payment-calculator__error {
      padding: 16px;
      background: #fef2f2;
      border-radius: 8px;
      border: 1px solid #fecaca;
      color: #991b1b;
    }

    .payment-calculator__error p {
      margin: 0 0 8px 0;
    }

    .payment-calculator__actions {
      display: flex;
      gap: 12px;
      justify-content: center;
      margin-top: 24px;
    }

    .payment-calculator__btn {
      padding: 10px 20px;
      border-radius: 6px;
      font-size: 14px;
      font-weight: 600;
      border: none;
      cursor: pointer;
      transition: all 0.2s ease;
    }

    .payment-calculator__btn--primary {
      background: #78227b;
      color: white;
    }

    .payment-calculator__btn--primary:hover:not(:disabled) {
      background: #6c1f6f;
    }

    .payment-calculator__btn--primary:disabled {
      opacity: 0.5;
      cursor: not-allowed;
    }

    .payment-calculator__btn--secondary {
      background: #e5e7eb;
      color: #000;
    }

    .payment-calculator__btn--secondary:hover {
      background: #d1d5db;
    }

    @media (max-width: 480px) {
      .payment-calculator__dialog {
        width: 95%;
        padding: 12px;
      }

      .payment-calculator__header {
        padding: 0 0 8px 0;
        margin-bottom: 8px;
      }

      .payment-calculator__title {
        font-size: 18px;
      }

      .payment-calculator__body {
        padding: 0;
      }

      .payment-calculator__header-row {
        margin-bottom: 12px;
        gap: 8px;
        padding-top: 8px;
      }

      .payment-calculator__back-btn {
        padding: 6px 0;
        font-size: 13px;
      }

      .payment-calculator__step-title {
        font-size: 16px;
      }

      .payment-calculator__schedule {
        padding: 10px;
      }

      .payment-calculator__summary-box {
        padding: 8px;
        margin-bottom: 10px;
      }

      .payment-summary-item {
        padding: 3px 0;
      }

      .payment-calculator__schedule-title {
        margin: 0 0 6px 0;
      }

      .payment-calculator__installments {
        margin: 0 0 10px 0;
      }

      .payment-calculator__installments--scrollable {
        max-height: 180px;
        padding: 6px;
      }

      .payment-option {
        padding: 14px;
      }

      .payment-option__icon {
        font-size: 24px;
      }

      .payment-option__title {
        font-size: 15px;
      }

      .payment-option__amount {
        font-size: 16px;
      }

      .payment-calculator__installment {
        flex-direction: row;
        align-items: center;
        gap: 8px;
        padding: 8px 0;
      }

      .payment-calculator__installment-number {
        font-size: 12px;
        flex: 1 1 auto !important;
      }

      .payment-calculator__installment-date {
        flex: 0 0 auto !important;
        text-align: right !important;
        font-size: 11px;
        margin-right: 8px;
        color: #000 !important;
      }

      .payment-calculator__installment-amount {
        flex: 0 0 auto !important;
        text-align: right !important;
        font-size: 14px;
        min-width: 70px;
      }

      .payment-calculator__actions {
        flex-direction: column;
      }

      .payment-calculator__btn {
        width: 100%;
      }
    }

    /* Extra small screens - reduce breakdown text size */
    @media (max-width: 375px) {
      .payment-calculator__program-title {
        font-size: 13px !important;
      }

      .payment-calculator__breakdown-row {
        font-size: 12px;
      }

      .payment-calculator__breakdown-total {
        font-size: 14px !important;
      }

      .payment-calculator__breakdown-total span {
        font-size: 14px !important;
      }
    }
  `;
  document.head.appendChild(style);

  /**
   * MANUAL PAYMENT FLOW
   * Handle custom payment plan confirmation
   */
  document.addEventListener("click", async function (e) {
    if (
      e.target &&
      e.target.classList.contains("select-program-button--custom")
    ) {
      e.preventDefault();

      const button = e.target;
      const customInstallmentsAttr = button.dataset.customInstallments;
      const variantId = button.dataset.variantId;
      const productId = button.dataset.productId;
      const productTitle = button.dataset.productTitle;
      const variantPrice = button.dataset.variantPrice;
      const customerId = button.dataset.customerId;
      const customerEmail = button.dataset.customerEmail;
      const customerFirstName = button.dataset.customerFirstName;
      const customerLastName = button.dataset.customerLastName;
      const programStartDate = button.dataset.programStartDate;
      const programTerm = button.dataset.programTerm;

      if (!customInstallmentsAttr) {
        console.error("No custom installments data found");
        alert("Error: Payment plan data missing. Please contact support.");
        return;
      }

      if (!variantId || !customerId) {
        console.error("Missing required data: variantId or customerId");
        alert("Error: Missing required information. Please contact support.");
        return;
      }

      try {
        const customInstallments = JSON.parse(customInstallmentsAttr);

        if (
          !Array.isArray(customInstallments) ||
          customInstallments.length === 0
        ) {
          console.error("Invalid custom installments format");
          alert("Error: Invalid payment plan format. Please contact support.");
          return;
        }

        // Confirm with user
        const totalAmount = customInstallments.reduce(
          (sum, inst) => sum + inst.amount,
          0,
        );
        const confirmMessage = `Confirm your custom payment plan:\n\n${customInstallments
          .map(
            (inst, idx) =>
              `Installment ${idx + 1}: €${inst.amount} - Due: ${inst.dueDate}`,
          )
          .join("\n")}\n\nTotal: €${totalAmount}\n\nProceed with this plan?`;

        if (!confirm(confirmMessage)) {
          return;
        }

        // Call backend to generate payment links with custom amounts
        await confirmCustomPaymentPlan(
          customInstallments,
          variantId,
          productId,
          productTitle,
          variantPrice,
          customerId,
          customerEmail,
          customerFirstName,
          customerLastName,
          programStartDate,
          programTerm,
        );
      } catch (error) {
        console.error("Error parsing custom installments:", error);
        alert("Error: Failed to process payment plan. Please contact support.");
      }
    }
  });

  /**
   * Confirm custom payment plan (MANUAL flow)
   * @param {Array<{amount: number, dueDate: string}>} customInstallments
   * @param {string} variantId
   * @param {string} productId
   * @param {string} productTitle
   * @param {string} variantPrice
   * @param {string} customerId
   * @param {string} customerEmail
   * @param {string} customerFirstName
   * @param {string} customerLastName
   * @param {string} programStartDate
   * @param {string} programTerm
   */
  async function confirmCustomPaymentPlan(
    customInstallments,
    variantId,
    productId,
    productTitle,
    variantPrice,
    customerId,
    customerEmail,
    customerFirstName,
    customerLastName,
    programStartDate,
    programTerm,
  ) {
    // Get button reference and original text outside try block
    const button = document.querySelector(".select-program-button--custom");
    const originalText = button ? button.textContent : "Confirm Payment Plan";

    try {
      // Show loading state
      if (button) {
        button.textContent = "Processing...";
        button.disabled = true;
      }

      // Transform customInstallments to format expected by backend
      // customInstallments = [{amount: 1500, dueDate: "2025-12-15"}, ...]
      // → installments = [{number: 1, amount: 1500, dueDate: "2025-12-15"}, ...]
      const installments = customInstallments.map((item, index) => ({
        number: index + 1,
        amount: item.amount,
        dueDate: item.dueDate,
      }));

      // Calculate total price from installments (WITHOUT deposit - already paid separately)
      const totalPrice =
        customInstallments.reduce((sum, inst) => sum + inst.amount, 0) * 100; // Convert to cents

      console.log("📤 Sending custom payment plan to backend:", {
        customerId,
        selectedProgramId: variantId,
        totalPrice,
        installments,
      });

      // Call API with installments (SAME format as AUTO flow!)
      const response = await fetch(`${WORKER_URL}/api/generate-payment-links`, {
        method: "POST",
        headers: { "Content-Type": "application/json" },
        body: JSON.stringify({
          customerId: customerId,
          customerEmail: customerEmail,
          customerFirstName: customerFirstName,
          customerLastName: customerLastName,
          variantId: variantId,
          totalPrice: totalPrice,
          installments: installments,
          isManualFlow: true, // Flag to distinguish MANUAL flow (custom installments from HubSpot)
          upsells: window.upsellsCalculator?.getLineItems() || [],
          upsellsTotal: window.upsellsCalculator?.getTotalAmount() || 0,
          programDetails: {
            name: productTitle,
            term: programTerm,
          },
        }),
      });

      const data = await response.json();

      if (!response.ok || !data.success) {
        throw new Error(data.error || "Failed to generate payment links");
      }

      console.log("✅ Payment links generated successfully");

      // Reload page to show payment links
      window.location.reload();
    } catch (error) {
      console.error("❌ Error confirming custom plan:", error);
      alert(
        "Error setting up payment plan. Please try again or contact support.",
      );

      // Restore button
      if (button) {
        button.textContent = originalText;
        button.disabled = false;
      }
    }
  }
})();
